import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { PATOLOGIE, CONDITION_CONTENT } from "@/data/siteData";
import { HOME } from "@/constants/testIds";

export default function Patologie() {
  return (
    <section id="patologie" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Patologie trattate</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Diagnosi accurate per l'intero apparato digerente.
          </h2>
          <p className="mt-6 text-gray-600 leading-relaxed">
            Un percorso clinico su misura, con un piano diagnostico ragionato e
            comunicazione trasparente dei risultati.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {PATOLOGIE.map((p) => {
            const Icon = Icons[p.icon] || Icons.CircleDot;
            const hasPage = !!CONDITION_CONTENT[p.slug];
            const inner = (
              <div
                data-testid={HOME.patologiaCard(p.slug)}
                className="patologia-card flex items-center gap-4 pl-5 pr-4 py-4 rounded-xl border border-gray-100 bg-white group"
              >
                <div className="w-9 h-9 rounded-full bg-[#0B4A5A]/5 text-[#0B4A5A] flex items-center justify-center group-hover:bg-[#C6A86B]/12 transition-colors">
                  <Icon size={17} strokeWidth={1.5} />
                </div>
                <span className="text-[15px] text-gray-800 font-medium leading-tight">
                  {p.name}
                </span>
                {hasPage && (
                  <Icons.ArrowUpRight
                    size={14}
                    strokeWidth={1.5}
                    className="ml-auto text-gray-300 group-hover:text-[#C6A86B] transition-colors"
                  />
                )}
              </div>
            );
            return hasPage ? (
              <Link key={p.slug} to={`/patologie/${p.slug}`}>
                {inner}
              </Link>
            ) : (
              <div key={p.slug}>{inner}</div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
